jQuery(document).ready(function ($) {
    // USP Atom
    var $usp = $('section.usp .usp-wrapper').flickity({
        wrapAround: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        watchCSS: true,
    });

    $usp.on( 'dragStart.flickity', function( event, pointer ) {
        document.ontouchmove = function (e) {
            e.preventDefault();
        }
    });
    $usp.on( 'dragEnd.flickity', function( event, pointer ) {
        document.ontouchmove = function (e) {
            return true;
        }
    });
});